import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Button } from '@material-ui/core';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
  title: {
    color: theme.palette.facet.accentBlue4,
    fontWeight: 'bold',
  },
  filterButton: {
    padding: 0,
    width: 70,
    fontSize: 11,
    fontWeight: 'bold',
    borderRadius: '10px',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.facet.accentBlue14,
  },
  selectedFilterButton: {
    backgroundColor: theme.palette.facet.accentBlue4,
    color: `${theme.palette.common.white} !important`,
  },
  hide: {
    display: 'none',
  },
});

const CalendarQuerySelector = ({
  classes,
  className,
  options,
  title,
  selectedQuery,
  onSelectQuery,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.title}>{title}</div>
      {options.map(option => (
        <Button
          disableElevation
          className={classes.filterButton}
          classes={{
            disabled: classes.selectedFilterButton,
          }}
          disabled={option.attr('id') === selectedQuery}
          onClick={() => onSelectQuery(option)}
          test={`scheduler-button-${option.attr('id')}-${title}`}
        >
          {option.attr('prompt')}
        </Button>
      ))}
    </div>
  );
};

CalendarQuerySelector.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  options: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  selectedQuery: PropTypes.string.isRequired,
  onSelectQuery: PropTypes.func.isRequired,
};

CalendarQuerySelector.defaultProps = {
  className: '',
};

export default withStyles(styles)(CalendarQuerySelector);
